module.exports = __webpack_public_path__ + "img/PerformanceManagement.7113b0b4.svg";